import { IconType } from '@sato/components';

import { trimLeadingStr } from './text.utils';

const protocolRegex = new RegExp('^https?://.+$');
const commonUrlPatterns = new RegExp(
  '^(www|oma|test-oma)..+.(com|fi|net)(/.*)?$'
);

export function isFilePath(dest: string) {
  return new RegExp(
    /^(https?:\/)?\/?(\[[:[:xdigit:]]+\]|[-.[:alnum:]]+)(:(\d+))?(\/.+)\.[a-zA-Z0-9]{1,4}$/i
  ).test(dest);
}

export function isInternalPath(dest: string | undefined) {
  try {
    if (!dest) return false;

    // check if the destination is an in-page anchor
    if (dest.charAt(0) === '#') return true;

    // check if the URL contains a protocol and compare hosts
    if (protocolRegex.test(dest)) {
      return window.location.host === new URL(dest).host;
    }
    // match some common URL patterns (e.g. www-subdomain)
    else if (commonUrlPatterns.test(dest)) {
      // prepend protocol and compare hosts
      return (
        window.location.host ===
        new URL(window.location.protocol + '//' + dest).host
      );
    }
    // try parsing URL and compare hosts (for example, for mailto and file paths)
    else if (dest.includes(':') || dest.includes('//')) {
      const parser = document.createElement('a');
      parser.href = dest;

      return window.location.host === parser.host;
    }

    // if the URL didn't match any external patterns, assume it's internal
    return true;
  } catch (err) {
    // if the URL invoked errors, assume it's internal (i.e. not of any recognizable pattern)
    return true;
  }
}

export const getLinkIcon = (
  dest: string | undefined,
  internalLinkIcon: 'chevronRight' | 'arrowRight' = 'arrowRight'
): IconType | undefined => {
  if (dest === undefined) return undefined;

  if (isFilePath(dest)) return 'download24';

  if (isInternalPath(dest)) return internalLinkIcon;

  return 'externalLink';
};

export const trimLeadingHash = (url: string) => trimLeadingStr('#', url);
